import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";

import queryString from "query-string";


import { getVehicleType } from "../../../model/car";

import { getLoggedProfile } from "../../../actions/sessionAct";
import { setBooking, getCSDetail } from "../../../actions/csDetailAct";


import { commonErr } from "../../common/errors";
import { stypes, formatTitleInUrl } from "../../common/common";
import { LoadingPage, LoadingInline } from "../../common/loading";

import { MessagePage } from "../../common/messagebox";

import Login from "../../login/login";
import SignUp from "../../login/signup";

import Header from "../../components/header";
import Footer from "../../components/footer";
// import CarDetailHeader from "../../car/components/cardetailheader";
import CSDetailCover from "./components/cscover";
// import RelatedCars from "./relatedcars";
import SideBar from "./components/sidebar";


import {
	InfoCS,
	OutsFeatures,
    AdvantageCS,
	PaperCS,
	Policy
} from "./components/infocs";

import avatar_default from "../../../static/images/avatar_default.png";


class CSDetailInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}

	componentDidMount() {
		getVehicleType().then((resp) => {
			if (resp.data.data) {
				this.setState({
					vehicleTypes: resp.data.data.vehicleTypes,
				});
			}
		});
	}

	isLogged = () => {
		const { profile } = this.props.session;
		return profile && profile.info && profile.info.uid;
	};

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	openSignupForm = () => {
		this.setState({
			showSignup: true,
		});
	};

	closeSignupForm = () => {
		this.setState({
			showSignup: false,
		});
	};

	showReportForm = () => {
		this.setState({
			showReportForm: true,
		});
	};

	closeReportForm = () => {
		this.setState({
			showReportForm: false,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	reportCarBtnClick = () => {
		if (!this.isLogged()) {
			this.openLoginForm();
		} else {
			this.showReportForm();
		}
	};

	// updatePrice = (car) => {
	// 	this.props.updatePrice(car);
	// };

	// wd, after getprice in bookingslidebar, callback this to set stata favbuttion
	// setStateFavButtonWD = (favWD) => {
	// 	this.setState({
	// 		favWD,
	// 	});
	// };

	render() {
		const loggedProfile = this.props.session.profile.info;
		const { detail, deliveryId, isMCalendar } = this.props;
		const { info, profiles, relatedCars, cars } = detail;
		const { vehicleTypes } = this.state;
		let vehicleName = "";

		const relatedList = [];
		if (relatedCars && relatedCars.length > 0 && cars) {
			for (let j = 0; j < relatedCars.length; j++) {
				for (let k = 0; k < cars.length; k++) {
					if (relatedCars[j] === cars[k].id) {
						relatedList.push(cars[k]);
					}
				}
			}
		}

		var ownerProfile;
		if (profiles && profiles.length > 0) {
			for (var i = 0; i < profiles.length; ++i) {
				if (profiles[i].uid === info.ownerId) {
					ownerProfile = profiles[i];
					break;
				}
			}
		}
		if (vehicleTypes && vehicleTypes.length > 0) {
			const vehicle = vehicleTypes.filter((type) => Number(type.id) == info.vehicleType);
			vehicleName = vehicle ? vehicle[0]?.name : ''
		}	
	
		

		return (
	
			<div className="details-car">
				<div className="m-container">
						<div className="details-box">
						
								<CSDetailCover info={info} vehicleName={vehicleName} />
								<SideBar
									onReportCar={this.reportCarBtnClick}
									closePopup={false}
									detail={detail}
									owner={ownerProfile}
									showLoginForm={this.openLoginForm}
									loggedProfile={loggedProfile}
									
									isMCalendar={isMCalendar}
								/>
								{/* <OutsFeatures info={info} vehicleName={vehicleName} /> */}
								<div className="details-inner">
									<PaperCS />
									<Policy info={info} />
								</div>
							<div className="clear" />
					</div>
					<Login
						show={this.state.showLoginForm}
						openSignupForm={this.openSignupForm}
						showModal={this.openLoginForm}
						hideModal={this.closeLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
					<SignUp
						show={this.state.showSignup}
						showModal={this.openSignupForm}
						hideModal={this.closeSignupForm}
						openLoginForm={this.openLoginForm}
						getLoggedProfile={this.getLoggedProfile}
					/>
				
					
				</div>
		
			</div>
		);
	}
}

class CSDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.LOADING,
			errMsg: "",
			isMCalendar: false,
		};
		this.stype = stypes.CS;
		this.isSD = false;
	}

	componentDidMount() {
		//overide filter by query params
		if (this.props.location && this.props.location.search) {
			const query = queryString.parse(this.props.location.search);
			//GA tracking
			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_campaign) {
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/" });
				cookie.save("_utm_campaign", query.utm_campaign, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_medium) {
				cookie.save("_utm_medium", query.utm_medium, { path: "/" });
				cookie.save("_utm_medium", query.utm_medium, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_term) {
				cookie.save("_utm_term", query.utm_term, { path: "/" });
				cookie.save("_utm_term", query.utm_term, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		}
		const { filter } = this.props.csFinding;

		const deliveryId =
			window.history.state !== null && window.history.state.deliveryId !== undefined
				? window.history.state.deliveryId
				: undefined;

		this.setState({
			deliveryId,
		});

		const { skuGroupId } = this.props.match.params;
      
		const { lat, lng, timeCS } = filter;



		const ex = {
			st: filter.startDate.valueOf(),
			et: filter.endDate.valueOf(),
			skuGroupId: skuGroupId,
			lat: lat,
			lon: lng,
			deliveryId: deliveryId,
			timeCS: timeCS
			// vw: "cd",
		};
		
		this.setBooking(ex);
		this.getCar(ex);

		//GA
		// const utmSrc = cookie.load("_utm_src") || "web_directly";
		// const utmExt = cookie.load("_utm_ext") || "no_label";
	
		// window.gtag("event", "VIEW_CAR_DETAIL", {
		// 	event_category: utmSrc,
		// 	event_label: utmExt,
		// 	campaign: { source: utmSrc },
		// });
		// window.fbq("track", "VIEW_CAR_DETAIL");
		window.scrollTo(0, 0);
		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow()

	}

	// Only receive from Redux
	componentDidUpdate(prevProps) {
		if (prevProps.match.params.skuGroupId != this.props.match.params.skuGroupId) {
			const { skuGroupId } = this.props.match.params;
			const { filter } = this.props.csFinding;
			const { lat, lng } = filter;

			const ex = {
				st: filter.startDate.valueOf(),
				et: filter.endDate.valueOf(),
				skuGroupId: skuGroupId,
				lat: lat,
				lon: lng,
				deliveryId: filter.deliveryId,
				timeCS: filter.timeCS
				// vw: "cd",
			};

			this.setBooking(ex)
			this.getCar(ex);
	
		}
	
	}

	UNSAFE_componentWillMount() {
		// Remove the default static meta description in favor of react helmets dynamic one
		if (document.querySelector("[name='description']")) {
			document.querySelector("[name='description']").remove();
		}
	}

	setBooking = (f) => {
		this.props.dispatch(setBooking(f));
	};

	checkWidthWindow = () => {
		if (window.innerWidth <= 991) {
			this.setState({
				isMCalendar: true
			})
		} else {
			this.setState({
				isMCalendar: false
			})
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow()
	};


	getCar = (ex) => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.props.dispatch(getCSDetail(ex)).then((resp) => {
			if (resp.action.payload.data.error === commonErr.SUCCESS) {
				this.setState({
					err: commonErr.SUCCESS,
				});
			}
		});
	};

	render() {
		const { err, deliveryId } = this.state;
		const csDetail = this.props.csDetail && this.props.csDetail.detail;

		var content;

		if (err === commonErr.LOADING) {
			content = (
				<section className="body">
					<LoadingPage />
				</section>
			);
		} else if (err >= commonErr.SUCCESS && csDetail) {
			// const structuredJSON = structuredDataSingle(carDetail, this.stype);

			content = (
				<React.Fragment>
					<Helmet>
						<title>{csDetail.info.name} | MIOTO</title>
						{/* <meta
							name="description"
							content={`Bạn đang cần thuê xe cho chuyến đi sắp tới? Đặt ngay xe ${carDetail.info.name} chỉ với giá từ ${
								this.stype === stypes.SD
									? `${carDetail.info.price}đ / ngày`
									: `${carDetail.info.wdShort ? carDetail.info.wdShort.price : "0"}đ /chuyến`
							} trên ứng dụng Mioto ngay!`}
						/> */}
						<meta content="Mioto" property="og:site_name" />
						{/* <meta content={`${carDetail.info.name.toLowerCase()}`} property="og:title"></meta> */}
						<meta
							data-react-helmet="true"
							content={`https://www.mioto.vn/car/${this.stype === stypes.SD ? "" : "wd/"}${formatTitleInUrl(
								csDetail.info.name
							)}/${csDetail.info.modelId}`}
							property="og:url"
						/>
						{/* <meta data-react-helmet="true" content={`${carDetail.info.photos[0].fullUrl}`} property="og:image"></meta> */}
					</Helmet>
					<section className="body">
						{/* <div className="header-car"> 
							<div className="m-container"> <a className="active" href="#1">Đặc điểm</a><a href="#2">Ưu điểm</a></div>
						</div> */}
					
						<CSDetailInfo
							isMCalendar={this.state.isMCalendar}
							detail={csDetail}
							// updatePrice={this.updatePrice}
							stype={this.stype}
							deliveryId={deliveryId}
						/>
					</section>
					{/* {!devMode && (
						<Helmet>
							<script type="application/ld+json">{structuredJSON}</script>
						</Helmet>
					)} */}
				</React.Fragment>
			);
		} else {
			content = <MessagePage message={"Không tìm thấy thông tin."} />;
		}

		return (
			<div className="mioto-layout">
				<Header notLineHeader={true} />
				
				{content}
				<Footer />
			</div>
		);
	}
}

function mapDetailState(state) {
	return {
		csFinding: state.csFinding,
		csDetail: state.csDetail,
	};
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}

CSDetailInfo = connect(mapSessionState)(CSDetailInfo);
CSDetail = connect(mapDetailState)(CSDetail);

export default CSDetail;
